import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { ButtonWidget } from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { ExplorerDropdownButton } from './ExplorerDropdownButton';
import { ExplorerFlyoutPanelProps } from './ExplorerFlyoutPanel';

export interface ExplorerDropdownProps {
  readonly buttonTitle?: string;
  readonly panelTitle: string;
  readonly testId: string;
  readonly renderPanel: (props: ExplorerFlyoutPanelProps) => JSX.Element;
  readonly renderButtonContent: (showingOrActive: boolean, disabled: boolean) => JSX.Element;
  readonly buttonStyleOverrides?: React.CSSProperties;
  readonly disabled?: boolean;
  readonly renderButtonContentOnly?: boolean;
}

export interface ExplorerDropdownState {
  showingPanel: boolean;
}

export class ExplorerDropdown extends React.Component<ExplorerDropdownProps, ExplorerDropdownState> {

  private buttonElement: HTMLElement;

  public constructor(props: ExplorerDropdownProps) {
    super(props);

    this.state = { showingPanel: false };
  }

  private setButtonRef = (element: ButtonWidget): void => {
    this.buttonElement = ReactDOM.findDOMNode(element) as HTMLElement;
  }

  private togglePanelVisibility = (): void => {
    this.setState((state) => {
      return {showingPanel: !state.showingPanel};
    });
  }

  private hidePanel = (): void => {
    this.setState({showingPanel: false});
  }

  private shouldRenderPanel = (): boolean => {
    return this.state.showingPanel;
  }

  private renderPanel = (): JSX.Element => {
    const panelProps: ExplorerFlyoutPanelProps = {
      anchorEl: this.buttonElement,
      testId: this.props.testId,
      title: this.props.panelTitle,
      onCloseRequest: this.hidePanel
    };

    return this.props.renderPanel(panelProps);
  }

  public render(): JSX.Element {
    return (
      <div>
          <ExplorerDropdownButton
            setButtonRef={this.setButtonRef}
            testId={this.props.testId}
            onClick={this.togglePanelVisibility}
            title={this.props.buttonTitle}
            renderButtonContent={this.props.renderButtonContent}
            showingPanel={this.shouldRenderPanel()}
            buttonStyleOverrides={this.props.buttonStyleOverrides}
            disabled={this.props.disabled}
            renderButtonContentOnly={this.props.renderButtonContentOnly}
          />
          {this.shouldRenderPanel() && this.renderPanel()}
      </div>
    );
  }
}
